import Component from 'vue-class-component';
import {Prop, Watch} from 'vue-property-decorator';
import {VuexObjectMixin} from '../../../Mixins';
import {Event, OrderItem, Product, Slot} from '../../../Models';
import Check from '../../Icons/Check.vue';
import {AdditionalOrderItemConfiguration} from '../../../Models/AdditionalOrderItemConfiguration';

@Component({
  components: {
    Check,
  },
})
export default class PersonalUseItem extends VuexObjectMixin {
  @Prop({required: true, type: AdditionalOrderItemConfiguration}) aoic: AdditionalOrderItemConfiguration | undefined;

  findProduct(productId: number): Product {
    return this.products.find(p => p.id === productId)!;
  }

  onChangeSelection() {
    if (this.canBeSelected) {
      this.$emit('selectPersonalUse', this.aoic, !!this.aoic?.personalUse);
    }
  }

  getSubProduct(orderItem: OrderItem): Product|null {
    return this.products.find(p => p.id === orderItem.productId) || null;
  }

  get event(): Event | undefined {
    return this.events.find(e => e.id === this.aoic?.getProduct()?.eventId);
  }

  get slot(): Slot | undefined {
    return this.slots.find(q => q.id === this.aoic?.orderItem?.slotId);
  }

  get isRegistrationRequired(): boolean {
    return this.aoic?.getProduct()?.isRegistrationRequired ?? false;
  }

  get canBeSelected(): boolean {
    return this.isRegistrationRequired;
  }
}
